<div class="navbar-wrapper">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/admin']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="house" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Dashboard</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/management/employees']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Employee Management</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/admin/employee-profile']" role="button" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Employee Profile</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/users"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Users</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/grievance"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Grievance</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/media-files"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Media Files</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/setting"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Setting</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/feedbacks"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Feedbacks</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/notice-boards"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Notice Boards</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/admin/notice-boards/notice-board-categories"]' routerLinkActive="active"
              class="nav-link">
              <span class="sidenav-mini-icon"> C </span>
              <span class="sidenav-normal"> Notice Board Categories </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/admin/notice-boards"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> N </span>
              <span class="sidenav-normal"> Notice Boards </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/faqs"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">FAQs</span>
      </a>

      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/admin/faqs/faq-categories"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> C </span>
              <span class="sidenav-normal"> FAQs
                Categories </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/admin/faqs"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> F </span>
              <span class="sidenav-normal"> FAQs </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/menus"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Menu</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/cms-pages"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Pages</span>
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/regions"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Regions</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/admin/regions"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> R </span>
              <span class="sidenav-normal"> Regions </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/admin/regions/states"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> S </span>
              <span class="sidenav-normal"> States </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/admin/regions/states/districts"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> D </span>
              <span class="sidenav-normal"> Districts </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/admin/regions/states/districts/schools"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> S </span>
              <span class="sidenav-normal"> Schools/Places </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]='["/admin/sanctioned-posts"]' routerLinkActive="active">
        <i-bs name="hash" width="1em" height="1em"></i-bs>
        <span class="nav-link-text ml-2">Post/Vacancy</span>
      </a>
      <div class="collapse" routerLinkActive="show">
        <ul class="nav nav-sm flex-column">
          <li class="nav-item">
            <a [routerLink]='["/admin/sanctioned-posts"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> S </span>
              <span class="sidenav-normal"> Sanctioned Post </span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]='["/admin/sanctioned-posts/vacant-posts"]' routerLinkActive="active" class="nav-link">
              <span class="sidenav-mini-icon"> V </span>
              <span class="sidenav-normal"> Vacant Post </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
